import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var Events = /*#__PURE__*/_createClass(function Events() {
  var _this = this;

  _classCallCheck(this, Events);

  _defineProperty(this, "on", function (callback) {
    if (typeof callback === 'function') {
      _this.listeners.push(callback);
    }
  });

  _defineProperty(this, "off", function (callback) {
    var index = _this.listeners.indexOf(callback);

    if (index >= 0) {
      _this.listeners.splice(index, 1);
    }
  });

  _defineProperty(this, "fire", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var i, listener;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < _this.listeners.length)) {
              _context.next = 8;
              break;
            }

            listener = _this.listeners[i];
            _context.next = 5;
            return listener(data);

          case 5:
            i++;
            _context.next = 1;
            break;

          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());

  this.listeners = [];
});

export { Events as default };
//# sourceMappingURL=events.js.map